import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { OrderModel, RequestTemplateDTO, RequestActDTO, StatusDTO, OrdersForNotification } from './model';
import { orderAdapter, OrderState } from './state';

export const stateName: string = 'order';

export const getError = (state: OrderState): any => state.error;

export const getIsLoading = (state: OrderState): boolean => state.isLoading;

export const getIsLoadingForNotification = (state: OrderState): boolean => state.isLoadingForNotification;

export const getFilterType = (state: OrderState): string => state.filterType;

export const getSelected = (state: OrderState): OrderModel => state.selected;

export const getSelectedEmployeeForId = (state: OrderState): number => state.selectedEmployeeForId;

export const getTemplate = (state: OrderState): RequestTemplateDTO => state.template;

export const getActs = (state: OrderState): RequestActDTO[] => state.acts;

export const getAllowedStatuses = (state: OrderState): StatusDTO[] => state.statuses;

export const selectOrderState: MemoizedSelector<object, OrderState> = createFeatureSelector<OrderState>(stateName);

export const selectForNotification = (state: OrderState): OrdersForNotification[] => state.forNotification;

export const selectAll: (state: object) => OrderModel[] = orderAdapter.getSelectors(selectOrderState).selectAll;

export const selectById = (id: number) =>
  createSelector(selectAll, (orders: OrderModel[]) => {
    return orders ? orders.find(p => p.id === id) : null;
  });

export const selectError: MemoizedSelector<object, any> = createSelector(selectOrderState, getError);

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectOrderState, getIsLoading);

export const selectIsLoadingForNotification: MemoizedSelector<object, boolean> = createSelector(
  selectOrderState,
  getIsLoadingForNotification
);

export const selectFilterType: MemoizedSelector<object, string> = createSelector(selectOrderState, getFilterType);

export const selectSelected: MemoizedSelector<object, OrderModel> = createSelector(selectOrderState, getSelected);

export const selectSelectedEmployeeForId: MemoizedSelector<object, number> = createSelector(selectOrderState, getSelectedEmployeeForId);

export const selectTemplate: MemoizedSelector<object, RequestTemplateDTO> = createSelector(selectOrderState, getTemplate);

export const selectActs: MemoizedSelector<object, RequestActDTO[]> = createSelector(selectOrderState, getActs);

export const selectAllowedStatuses: MemoizedSelector<object, StatusDTO[]> = createSelector(selectOrderState, getAllowedStatuses);

export const selectOrdersForNotification: MemoizedSelector<object, OrdersForNotification[]> = createSelector(
  selectOrderState,
  selectForNotification
);
